import * as React from "react";
import Button from "@material-ui/core/Button";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";

import Accordion from "@material-ui/core/ExpansionPanel";
import AccordionDetails from "@material-ui/core/ExpansionPanelDetails";
import AccordionSummary from "@material-ui/core/ExpansionPanelSummary";
//import Typography from "@material-ui/core/Typography";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Grid from "@material-ui/core/Grid";

import Component from "../../../../AbstractComponent";
import BillDetails from "./BillDetails";
import { formatDate } from "../utils/formatDate";

export default class Tenant extends Component {
  public state = {};
  constructor(public props) {
    super(props);

    this.onNextStep = this.onNextStep.bind(this);
    this.onBack = this.onBack.bind(this);
    this.renderTenantsDistributionTable = this.renderTenantsDistributionTable.bind(this);
    this.tenantPeriodeAsString = this.tenantPeriodeAsString.bind(this);
  }

  public onNextStep = () => {
    this.props.setState({
      ...this.props.state,
      ...this.state,
      activeStep: 4,
    });
  };

  public onBack = () => {
    this.props.setState({
      ...this.props.state,
      ...this.state,
      activeStep: 2,
    });
  };

  public tenantPeriodeAsString = (props, unitId) => {
    const contracts = props.state.unit_calculations.intersecting_contracts_by_unit[unitId];
    const contract = contracts[0];
    const contractId = contract.id;
    const periodsForContract = props.state.unit_calculations.periods_by_contract[contractId];
    const period = periodsForContract[0];
    const firstDay = period.firstDate;
    const lastDay = period.lastDate
    return (formatDate(firstDay) + ' - ' + formatDate(lastDay));
  }

  public renderDistributionHeader = () => {
    return (
      <Grid container style={{padding:"0 2px", fontWeight:100, color:"gray"}}>
        <Grid item xs={3} style={{padding:"0px 12px 6px"}}>
        {this.trans("coach/new-bill-settlement/steps/tenant/tenants/header/unit")}
        </Grid>
        <Grid item xs={3} style={{padding:"0px 12px 6px"}}>
          {this.trans("coach/new-bill-settlement/steps/tenant/tenants/header/tenant")}
        </Grid>
        <Grid item xs={3} style={{padding:"0px 12px 6px", display:"flex", justifyContent:"right"}}>
          {this.trans("coach/new-bill-settlement/steps/tenant/tenants/header/contract")}
        </Grid>
        <Grid item xs={3} style={{padding:"0px 12px 6px", display:"flex", justifyContent:"right"}}>
          {this.trans("coach/new-bill-settlement/steps/tenant/tenants/header/to-pay")}
        </Grid>
      </Grid>
    )
  }

  public renderTenantsDistributionTable() {
    if (!this.props.state.unit_calculations) {
      return null;
    }

    return this.props.state.unit_calculations.units.map( (unit, idx) => (
      <Grid key={idx} container spacing={3}>
        <Grid item xs={12}>
          {
            (this.props.state.unit_calculations.tenants_by_unit[unit.id] || [])
            .map( (tenant) => (this.props.state.unit_calculations.contracts_by_tenant[tenant.id])
              .sort( (a,b) => a.id - b.id)
              .map( (contract, idx) => (
                <Accordion key={idx}>
                  
                  {/*** Summary of tenant's contract ***/}

                  <AccordionSummary style={{backgroundColor:"#f8f8f8"}}>  
                  {/* This property was removed from AccordionSummary for aligmnent purpose: expandIcon={<ExpandMoreIcon />} */}
                    <Grid container spacing={3} justify="space-between">
                      <Grid item xs={3}>
                        <div style={{ fontSize: "1.2", fontWeight: "bold" }}>{this.trans(unit?.type?.label) + ' ' + unit.unitNumber}</div>
                      </Grid>
                      <Grid item xs={3}>
                        <div style={{ fontSize: "1.2", fontWeight: "bold" }}>{tenant.displayName}</div>
                      </Grid>
                      <Grid item xs={4}>
                        <div style={{ fontSize: "1.2", fontWeight: "bold", display: "flex", justifyContent: "right"}}>
                          {/*(this.tenantPeriodeAsString(this.props, unit.id))*/}
                          {this.formatter.formatDate(contract.periodIntersectingWithBill.firstDate) + "  -  " + this.formatter.formatDate(contract.periodIntersectingWithBill.firstDate)}
                          {/*contract.firstDate + " - " + contract.contractLastDate*/}
                        </div>
                      </Grid>
                      <Grid item xs={2}>
                        <div style={{ fontSize: "1.2", fontWeight: "bold", display: "flex", justifyContent: "right" }}>
                          {(( this.props.state.unit_calculations.to_pay_by_contracts[contract.id] || 0 )).toFixed(2)}
                          {" "}EUR
                        </div>
                      </Grid>
                    </Grid>
                  </AccordionSummary>

                  {/*** List of periods for tenant's contract ***/}

                  <AccordionDetails style={{ flexDirection: "column", backgroundColor: "#fcfcfc" }}>
                    <Grid container direction="column">
                      { this.props.state.unit_calculations.periods_by_contract[contract.id]
                        .map( (period, idx) => (
                          <Grid item xs={12} key={idx}>
                            <Grid container spacing={3} direction="row">
                              <Grid item xs={3} style={{display: "flex", justifyContent: "right"}}>
                                <div style={{ opacity: 0 }}>{contract.id}</div>
                              </Grid>
                              <Grid item xs={3} style={{display: "flex", justifyContent: "right"}}>
                                <div style={{ opacity: 0 }}>{contract.id}</div>
                              </Grid>
                              <Grid item xs={4} style={{display: "flex", justifyContent: "right"}}>
                                {this.formatter.formatDate(period.firstDate) + "  -  " + this.formatter.formatDate(period.lastDate)}
                              </Grid>
                              <Grid item xs={2} style={{display: "flex", justifyContent: "right"}}>
                                {(period.to_pay || 0).toFixed(2)} EUR 
                              </Grid>
                            </Grid>
                          </Grid>
                        ))
                      }
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ))
            )
          }
        </Grid>
      </Grid>
    ));
  }

  public render() {
    return (
      <div className="coach_newBillSettlement_step_wrapper">
        <div className="coach_newBillSettlement_step_title">
          {this.props.state.address?.displayName ?? ""}
        </div>
        <BillDetails {...this.props} />

        {/*** Distribution list ***/}

        <div className="coach_newBillSettlement_step_section_content">
          <div className="coach_newBillSettlement_step_section_header">
            <div className="coach_newBillSettlement_step_section_header_title">
              {this.trans("coach/new-bill-settlement/steps/tenant/section-two/title")}
            </div>
          </div>

          <div className="coach_newBillSettlement_step_section_content">
            {this.renderDistributionHeader()}
            {this.renderTenantsDistributionTable()}
          </div>

          <div className="coach_newBillSettlement_step_section_content_item_row">
            <div className="coach_newBillSettlement_step_section_content_item_row_hint">
              {this.trans("coach/new-bill-settlement/steps/tenant/section-two/hint")}             
            </div>
          </div>

        </div>

        {/*** Next/Previous buttons ***/}

        <div className="coach_newBillSettlement_actionButtons">
          <Button
            variant="contained"
            onClick={this.onBack}
            startIcon={<ArrowBackIos />}
          >
            {this.trans("coach/new-bill-settlement/action-buttons/back")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.onNextStep}
            endIcon={<ArrowForwardIosIcon />}
          >
            {this.trans("coach/new-bill-settlement/action-buttons/next")}
          </Button>
        </div>

      </div>
    );
  }
}
